import ArrowButton from '@/components/molecules/arrowButton'
import Container from '@/components/templates/container'
import Spacer from '@/components/atoms/spacer'
import Title from './title'
import Script from 'next/script'

const Instagram = ({ title, elfsightID, link }) => (
  <Container className="mb-largeMobile lg:mb-largeDesktop">
    <Spacer />
    <div className="relative w-full mt-largeMobile lg:mt-largeDesktop">
      <Title text={title} />
      <Script src="https://static.elfsight.com/platform/platform.js" />
      <div className="w-full mt-smallMobile lg:mt-mediumDesktop overflow-x-hidden">
        <div className={elfsightID} />
      </div>
      <ArrowButton
        name="OUR INSTAGRAM"
        target="_blank"
        link={link}
        className="lg:mx-auto mt-smallMobile lg:mt-mediumDesktop"
      />
    </div>
  </Container>
)

export default Instagram
